// src/sectors/pilates/sessions/components/calendar/MobileDayList/parts/EmptyDayCard.jsx
import React from 'react';
import Icon from '@mui/material/Icon';
import { alpha } from '@mui/material/styles';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

export default function EmptyDayCard({ day, editMode, onEmptyDayAdd, onCreate }) {
  return (
    <MDBox
      sx={(t) => ({
        py: 1.05,
        px: 1.0,
        borderRadius: '16px',
        border: `1px dashed ${alpha(
          t.palette.text.primary,
          t.palette.mode === 'dark' ? 0.18 : 0.16
        )}`,
        background: t.palette.mode === 'dark' ? alpha('#ffffff', 0.03) : alpha('#0b1220', 0.03),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        cursor: editMode || onEmptyDayAdd ? 'pointer' : 'default',
      })}
      onClick={() => {
        if (onEmptyDayAdd) return onEmptyDayAdd(day);
        if (editMode) return onCreate();
        return null;
      }}
    >
      <MDBox>
        <MDTypography component="div" variant="button" fontWeight="bold" sx={{ lineHeight: 1.1 }}>
          Seans yok
        </MDTypography>
        <MDTypography
          component="div"
          variant="caption"
          sx={(t) => ({ color: t.palette.text.secondary })}
        >
          {editMode ? 'Düzenleme modunda ekleyebilirsin' : 'Düzenleme modunda ekleyebilirsin'}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}
